module.exports = __webpack_public_path__ + "static/img/ige-xao-logo.76cad51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/ige-xao-logo.png
// module id = x6Fr
// module chunks = 0